import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import axios from '../Axiosinstance';
import Header from './Header';
import { Modal } from 'react-bootstrap';
import { FaPlus } from 'react-icons/fa';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { Grid, TextField, FormControl, Button, RadioGroup, FormControlLabel, Radio, Typography, Select, MenuItem, InputLabel, FormHelperText } from "@mui/material";


function NewFacilitator({ onFormSubmit }) {
  const navigate = useNavigate();
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const validateForm = () => {
  const validationErrors = {};
  const trimmed = {
    salutation: salutation.trim(),
    name: name.trim(),
    nric: nric.trim().toUpperCase(),
    email: email.trim(),
    phone: phone.trim(),
    qualification: qualification.trim(),
    gender: gender.trim(),
    password: password.trim(),
  };

  if (!trimmed.salutation) validationErrors.salutation = 'Salutation is required';
  if (!trimmed.name) validationErrors.name = 'Name is required';
  if (!trimmed.nric) {
    validationErrors.nric = 'NRIC/FIN No is required';
  } else if (!validateNRIC(trimmed.nric)) {
    validationErrors.nric = 'Invalid NRIC/FIN format. Example: S1234567D';
  }

  if (!trimmed.email) {
    validationErrors.email = 'Email is required';
  } else if (!/^\S+@\S+\.\S+$/.test(trimmed.email)) {
    validationErrors.email = 'Invalid email format';
  }

  if (!trimmed.phone) {
    validationErrors.phone = 'Phone is required';
  } else if (!/^\d{8}$/.test(trimmed.phone)) {
    validationErrors.phone = 'Phone must be 8 digits';
  }

  if (!trimmed.qualification) validationErrors.qualification = 'Qualification is required';
  if (!trimmed.gender) validationErrors.gender = 'Gender is required';
  if (!trimmed.password) validationErrors.password = 'Password is required';

  return { isValid: Object.keys(validationErrors).length === 0, validationErrors, trimmed };
};


  const [facilitator, setFacilitator] = useState({
    salutation: '',
    nric: '',
    email: '',
    phone: '',
    // educational_level: '',
    qualification: '',
    domain: '',
    gender: '',
    password: '',
    name: '',
    // usertype: '',
  });
  const [error, setError] = useState('');

  const [errors, setErrors] = useState({
    salutation: '',
    nric: '',
    email: '',
    phone: '',
    // educational_level: '',
    qualification: '',
    // domain: '',
    gender: '',
    password: '',
    name: '',
    // usertype: '',
  });


  const {
    salutation,
    nric,
    email,
    phone,
    // educational_level,
    qualification,
    // domain,
    gender,
    password,
    name,
    // usertype
  } = facilitator;

  const validateNRIC = (nric) => {
    const pattern = /^[STFGM]\d{7}[A-Z]$/i; // case-insensitive
    return pattern.test(nric);
  };
  const onInputChange = (e) => {
    const { name, value } = e.target;
    const upperValue = value.toUpperCase();

    // Update the facilitator state correctly
    setFacilitator((prev) => ({
      ...prev,
      [name]: value // Use "name" instead of "e.target.name"
    })); // <-- Closing parenthesis was missing here

    // Clear the error message for the specific field
    setErrors((prevErrors) => ({
      ...prevErrors,
      [name]: ''
    }));
    if (name === "nric") {
      if (!validateNRIC(upperValue)) {
        setErrors((prevErrors) => ({
          ...prevErrors,
          nric: "Invalid NRIC/FIN format. Example: S1234567D",
        }));
      }
    }
  };

  const checkFacilitatorExists = async (name, email) => {
    try {
      const response = await axios.get('facilitators', { params: { name, email } });
      const emailExists = response.data.some(facilitator => facilitator.email === email);
      const nricExists = response.data.some(facilitator => facilitator.nric === nric);
      return { emailExists, nricExists };
    } catch (error) {
      console.error("Error checking facilitator:", error);
      return { emailExists: false, nricExists: false };
    }
  };

  const createFacilitator = async (facilitatorData) => {
    try {
      const response = await axios.post('facilitator', facilitatorData);
      return response.data.id;
    } catch (error) {
      console.error('Error creating facilitator:', error);
      setError('Error creating facilitator');
      return null;
    }
  };

  const createUser = async (userData) => {
    try {
      await axios.post('auth/create-user', userData);
      return true;
    } catch (error) {
      console.error('Error adding user:', error);
      setError('Error adding user');
      return false;
    }
  };

const onSubmit = async (e) => {
  e.preventDefault();
  if (loading) return;

  setLoading(true);
  setError('');
  setErrors({});

  const { isValid, validationErrors, trimmed } = validateForm();

  if (!isValid) {
    setErrors(validationErrors);
    setLoading(false);
    return;
  }

  try {
    // Check if facilitator already exists
    const { emailExists, nricExists } = await checkFacilitatorExists(trimmed.name, trimmed.email);

    if (emailExists || nricExists) {
      setError(emailExists ? 'Email already exists.' : 'NRIC already exists.');
      setLoading(false);
      return;
    }

    // Prepare facilitator data
    const facilitatorPayload = {
      ...facilitator,
      ...trimmed,
    };

    const newFacilitatorId = await createFacilitator(facilitatorPayload);
    if (!newFacilitatorId) {
      setLoading(false);
      return;
    }

    // Create user
    const userData = {
      email: trimmed.email,
      name: trimmed.name,
      username: trimmed.name,
      password: trimmed.password,
      usertype: 2,
      sfid: newFacilitatorId,
    };

    const userCreated = await createUser(userData);
    if (!userCreated) {
      setLoading(false);
      return;
    }

    toast.success('Facilitator added successfully!', { position: 'top-right', autoClose: 3000 });
    navigate('/facilitor');
    onFormSubmit();
  } catch (err) {
    console.error('Unexpected error during submission:', err);
    setError('Something went wrong. Please try again.');
  } finally {
    setLoading(false);
  }
};



  const [isFormDirty, setIsFormDirty] = useState(false);

  const handleInputChange = () => {
    if (!isFormDirty) {
      setIsFormDirty(true);
    }
  };


  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (isFormDirty) {
        event.preventDefault();
        event.returnValue = 'You have unsaved changes. Are you sure you want to leave this page?';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);


    return () => {
      window.removeEventListener('beforeunload', handleBeforeUnload);
    };
  }, [isFormDirty]);




  const handleCancel = () => {


    {
      onFormSubmit();
    }
  };



  const handleConfirmSave = () => {
    setShowConfirmationModal(false);
    onFormSubmit();
  };

  const handleCancelSave = () => {
    setShowConfirmationModal(false);
  };



  return (

    <div style={{
      maxWidth: '1000px',
      background: '#ffffff',
      padding: '20px',
      boxShadow: '0px 0px 2px 0px #000000',
      borderRadius: '10px',
      margin: 'auto',
    }}>
      <Typography variant="h5" gutterBottom>New Facilitator (AEG International College)</Typography>
      <hr style={{ marginTop: '1%' }} />
      {error && <div className="text-danger">{error}</div>}
      <form onSubmit={onSubmit} style={{ display: 'flex', flexDirection: 'column' }}>
        <Grid container spacing={3}>
          {/* Left Column */}
          <Grid item xs={12} md={6}>
            <FormControl fullWidth margin="normal">
              <InputLabel>Salutation</InputLabel>
              <Select
                name="salutation"
                value={facilitator.salutation}
                onChange={onInputChange}
                label="Salutation"
                required
              >
                <MenuItem value="">Select Salutation</MenuItem>
                <MenuItem value="Mr.">Mr.</MenuItem>
                <MenuItem value="Mrs.">Mrs.</MenuItem>
                <MenuItem value="Ms.">Ms.</MenuItem>
              </Select>
              {errors.salutation && <FormHelperText error>{errors.salutation}</FormHelperText>}
            </FormControl>

            <TextField
              label="Name"
              name="name"
              value={facilitator.name}
              onChange={onInputChange}
              fullWidth
              required
              inputProps={{ maxLength: 30 }}
              error={!!errors.name}
              helperText={errors.name || ""}
              margin="normal"
            />

            <TextField
              label="NRIC/FIN No"
              name="nric"
              value={facilitator.nric}
              onChange={onInputChange}
              fullWidth
              required
              inputProps={{ maxLength: 9 }}
              error={!!errors.nric}
              helperText={errors.nric || ""}
              margin="normal"
            />

            <TextField
              label="Email"
              name="email"
              value={facilitator.email}
              onChange={onInputChange}
              fullWidth
              required
              error={!!errors.email}
              helperText={errors.email || ""}
              margin="normal"
            />

            <TextField
              label="Phone"
              name="phone"
              value={facilitator.phone}
              onChange={onInputChange}
              fullWidth
              required
              error={!!errors.phone}
              helperText={errors.phone || ""}
              margin="normal"
              inputProps={{ maxLength: 8 }}
            />
          </Grid>

          {/* Right Column */}
          <Grid item xs={12} md={6}>
            <TextField
              label="Qualification"
              name="qualification"
              value={facilitator.qualification}
              onChange={onInputChange}
              fullWidth
              required
              error={!!errors.qualification}
              helperText={errors.qualification || ""}
              margin="normal"
            />

            <TextField
              label="Password"
              name="password"
              value={facilitator.password}
              onChange={onInputChange}
              fullWidth
              required
              error={!!errors.password}
              helperText={errors.password || ""}
              type="password"
              inputProps={{ maxLength: 12 }}
              margin="normal"
            />

            <FormControl component="fieldset" fullWidth required margin="normal">
              <RadioGroup
                name="gender"
                value={facilitator.gender}
                onChange={onInputChange}
                row
              >
                <FormControlLabel value="Male" control={<Radio />} label="Male" />
                <FormControlLabel value="Female" control={<Radio />} label="Female" />
                <FormControlLabel value="Other" control={<Radio />} label="Other" />
              </RadioGroup>
              {errors.gender && <FormHelperText error>{errors.gender}</FormHelperText>}
            </FormControl>

            <div style={{ display: 'flex', marginTop: '20px' }}>
              <Button
                variant="contained"
                color="secondary"
                onClick={handleCancel}
                style={{ padding: '8px 15px', borderRadius: '7px', marginRight: '5px' }}

              >
                Cancel
              </Button>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                // startIcon={<FaPlus />}
                style={{ padding: '8px 15px', borderRadius: '7px' }}

                disabled={loading}
              >
                {loading ? 'Adding...' : 'Submit'}
              </Button>
              
            </div>
            <ToastContainer />
          </Grid>
        </Grid>
      </form>
    </div>



  );
}

const Batchess = ({ onFormSubmit }) => {
  return (
    <div>

      <NewFacilitator onFormSubmit={onFormSubmit} />
    </div>
  );
};


export default Batchess;

